import React from 'react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { FormControl, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { BotIdPickerProps, BotIdPickerSchema } from './schema';
import { useAsync } from 'react-use';
import { useApi } from '@backstage/core-plugin-api';
import { DEFAULT_NAMESPACE, parseEntityRef } from '@backstage/catalog-model';

const BotIdPicker = (props: BotIdPickerProps) => {
  const {
    onChange,
    required,
    schema: { title = 'ProjectId' },
    rawErrors,
    idSchema,
    formContext,
  } = props;
  const catalogApi = useApi(catalogApiRef);

  let projectId = '';

  if (!formContext.formData.project) {
    projectId = '0';
  } else {
    const projectEntity = parseEntityRef(formContext.formData.project, {
      defaultKind: 'Project',
      defaultNamespace: DEFAULT_NAMESPACE,
    });
    projectId = projectEntity.name;
  }

  const { value: entities, loading } = useAsync(async () => {
    const { items } = await catalogApi.getEntities({
      filter: { 'spec.project': projectId },
    });
    return items;
  }, [projectId]);

  const botNos =
    entities?.map(e => parseInt(e.metadata.name.split('-')[1], 10)) ?? [];

  let newBotNo = '1';

  if (botNos.length !== 0) {
    newBotNo = (Math.max(...botNos) + 1).toString();
  }

  const newBotId = `${projectId}-${newBotNo}`;

  onChange(newBotId);

  return (
    <FormControl required={required} error={rawErrors?.length > 0 && !newBotId}>
      <Autocomplete
        id={idSchema?.$id}
        value={newBotId}
        disabled
        loading={loading}
        options={[newBotId] || []}
        autoSelect
        renderInput={params => (
          <TextField
            {...params}
            label={title}
            variant="outlined"
            required={required}
            InputProps={params.InputProps}
          />
        )}
      />
    </FormControl>
  );
};

export const BotIdPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'BotIdPicker',
    component: BotIdPicker,
    schema: BotIdPickerSchema,
  }),
);
